import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useInsiderFAQContents } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/useInsiderFAQContents";
import { useInsiderHelpCenterArticleLink } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderHelpCenterArticleLink";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Span, Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var InsiderFAQSection = function(param) {
    var _param_isMarketingPage = param.isMarketingPage, isMarketingPage = _param_isMarketingPage === void 0 ? true : _param_isMarketingPage;
    var helpCenterLink = useInsiderHelpCenterArticleLink();
    var faqContents = useInsiderFAQContents();
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $isMarketingPage: isMarketingPage,
        children: [
            /*#__PURE__*/ _jsx(Accordion, {
                titleAlignment: "left",
                items: faqContents,
                title: strictLocalize({
                    id: "CprXac",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You may be wondering..."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ItemTitleContainer, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "subheadingSansRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "jwpSbc",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "For more information about Insider, visit our "
                            },
                            {
                                type: 8,
                                value: "LinkFormatting",
                                children: [
                                    {
                                        type: 0,
                                        value: "Help Center"
                                    }
                                ]
                            }
                        ],
                        values: {
                            LinkFormatting: getLinkFormatting(helpCenterLink)
                        }
                    })
                })
            })
        ]
    });
};
var Wrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-bcb47950-0"
})([
    "justify-self:center;order:100;width:100%;background-color:",
    ";margin:",
    ";",
    "{padding:",
    ";}",
    "{max-width:1024px;}"
], Core.surface.inverse, function(param) {
    var $isMarketingPage = param.$isMarketingPage;
    return getSpacing($isMarketingPage ? "3x" : "9x", 0, $isMarketingPage ? "8x" : 0);
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $isMarketingPage = param.$isMarketingPage;
    return $isMarketingPage ? getSpacing("5x", "7x") : 0;
}, responsiveMediaQueries.desktopAndAbove);
var ItemTitleContainer = styled(Row).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-bcb47950-1"
})([
    "padding:",
    ";width:100%;border-bottom:1px solid ",
    ";"
], getSpacing("2x", "3x"), Core.border.muted);
var getLinkFormatting = function(linkTo) {
    return function getLinkFormatting(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            linkTo: linkTo,
            variant: "tertiary",
            target: "_blank",
            children: /*#__PURE__*/ _jsx(Span, {
                variant: "subheadingSansRegular",
                children: chunks
            })
        });
    };
};
